import { createSelector } from 'reselect';

const getHomework      =   (state)  => state.homework.entities;
const getDate       =   (state, props) => props.date;

const getHomeworkByDay = createSelector(
    [getHomework, getDate],
    (homework, date) => {

        let allHomeworkItems = homework.allIds.map((homeworkId) => homework.byId[homeworkId]);

        let month = parseInt(date.getMonth() + 1);
        if(month < 10) {
            month = `0${month}`;
        }

        let day = parseInt(date.getDate());
        if(day < 10) {
            day = `0${day}`;
        }

        let dateString = `${date.getFullYear()}-${month}-${day}`;
        
        return allHomeworkItems.filter((homeworkItem, index) => homeworkItem.date == dateString);
    }
);

export default getHomeworkByDay;
